import { Service } from "../glue/Kernel.js";

// A leaf service that holds this Kernel's configuration — a flat key -> value map — so
// other services read `serviceAPI.get('config').get('port')` instead of reaching for
// module-level constants. It depends on nothing, so it's always ready for siblings to
// query.
//
// Shared between the two Kernels (a genuine shared service, not a coincidence): the
// server fills it with port / tick / seed, the client with seed / server URL — same
// service, different values. Values are given at construction, since a Kernel's config
// is known up front; `set` allows a runtime override where one is wanted.
export class ConfigService extends Service {
    constructor(values = {}) {
        super();
        this.values = { ...values };
    }

    get(key, fallback) {
        return Object.prototype.hasOwnProperty.call(this.values, key) ? this.values[key] : fallback;
    }

    has(key) {
        return Object.prototype.hasOwnProperty.call(this.values, key);
    }

    all() {
        return { ...this.values };
    }

    set(key, value) {
        this.values[key] = value;
        return value;
    }
}
